import { cn } from '@/lib/utils';

export interface MeterSegment {
  /** 全体に対する比率 (0-1) */
  ratio: number;
  className: string;
  label?: string;
}

/**
 * 横棒。予実の進捗と資産化比率の両方で使う。
 * 角丸は使わず、トラックの上に矩形を並べるだけ。
 */
export function Meter({
  segments,
  markerRatio,
  className,
}: {
  segments: MeterSegment[];
  /** 「本日時点のペース基準」のような縦線 */
  markerRatio?: number;
  className?: string;
}) {
  return (
    <div className={cn('relative h-2.5 w-full bg-track', className)}>
      <div className="flex h-full w-full">
        {segments.map((segment, index) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: 位置がそのまま意味を持つ帯なので並べ替わらない
            key={index}
            className={segment.className}
            style={{ width: `${Math.min(100, Math.max(0, segment.ratio * 100))}%` }}
            title={segment.label}
          />
        ))}
      </div>
      {markerRatio !== undefined ? (
        <span
          aria-hidden
          className="absolute -top-1 block h-4.5 w-px bg-ink-faint"
          style={{ left: `${Math.min(100, Math.max(0, markerRatio * 100))}%` }}
        />
      ) : null}
    </div>
  );
}
